import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipseOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 9,
		cy: 9,
		rx: 6,
		ry: 6,
		fill: "#004FD6"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		r: 8.5,
		stroke: "#002F77"
	})]
});
export default SvgEllipseOutline;
